import { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { CustomTextField } from "../TextFields";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

type props = {
    label?: string,
    required?: boolean,
    error: boolean,
    helperText?: string,
    onChange: (event: any) => void,
}

export default function PassWordInput({ required = false, label = "کلمه عبور", error, helperText, onChange }: props) {
    const [showPass, setShowPass] = useState<boolean>(false)
    return (
        <CustomTextField
            label={label}
            type={showPass ? "text" : "password"}
            error={error}
            required={required}
            helperText={helperText}
            style={{ direction: "ltr" }}
            sx={{
                "& .MuiInputBase-input": { textAlign: "left", direction: "ltr" }
            }}
            onChange={onChange}
            InputProps={{
                endAdornment:
                    <InputAdornment sx={{ cursor: "pointer" }} position="end" onClick={() => setShowPass(!showPass)}>
                        <IconButton>
                            {showPass ?

                                <VisibilityIcon sx={{ color: "divider" }} width="18px" height="18px" />
                                :
                                <VisibilityOffIcon sx={{ color: "divider" }} width="18px" height="18px" />
                            }
                        </IconButton>
                    </InputAdornment>,
            }}
        />
    )
}